import { useNavigate } from "react-router-dom";
import { t } from "ttag";

import { usePortalUser } from "@/app/hooks";
import { ROUTES } from "@/app/router";
import { usePortalUserStore } from "@/app/stores";
import { SCHEDULE_BLOCK_REASON } from "@/shared/domains/appointments/constants";
import {
  Banner,
  Button,
  CardSkeleton,
  HeartsIcon,
  PopoverTooltip,
} from "@/shared/ui";
import { tw } from "@/shared/utils";

export const JourneySupportBanner = () => {
  const isBookingDisabled = usePortalUserStore(
    (state) => !state.portalUser?.journeySupport?.canSchedule,
  );

  const { isFetching: isFetchingPortalUser, data: portalUser } =
    usePortalUser();

  const scheduleBlockReason =
    portalUser?.journeySupport?.journeySupportBlockReason;

  const navigate = useNavigate();

  const handleClick = () => {
    navigate(ROUTES.COACHING.JOURNEY_SUPPORT_SCHEDULE);
  };

  if (isFetchingPortalUser) {
    return (
      <Banner.Root color="secondary">
        <CardSkeleton className="bg-transparent" />
      </Banner.Root>
    );
  }

  const SCHEDULE_BLOCK_REASON_MESSAGES = {
    [SCHEDULE_BLOCK_REASON.INTAKE_FORM_COMPLETED_TOO_RECENTLY]: t`Please complete your intake form. If you already did, come back later to book your session.`,
    [SCHEDULE_BLOCK_REASON.ALREADY_SCHEDULED]: t`Session already booked. Check it out in your agenda.`,
  } as const;

  return (
    <Banner.Root
      color="secondary"
      className={tw(isBookingDisabled && "opacity-50")}
    >
      <Banner.Header>
        <Banner.Label>
          <HeartsIcon className="size-4" />
          {t`Journey support`}
        </Banner.Label>

        <Banner.Title>
          {t`Book a 1:1 journey support coaching session`}
        </Banner.Title>
      </Banner.Header>

      <Banner.Content>
        <Banner.Description>
          {t`Personalized support from a Health Coach to help you set goals, manage challenges and stay on track.`}
        </Banner.Description>
      </Banner.Content>

      <Banner.Actions>
        <Button size="lg" variant="secondary" onClick={handleClick}>
          {t`Book now`}
        </Button>
      </Banner.Actions>

      {isBookingDisabled && scheduleBlockReason && (
        <PopoverTooltip.Root>
          <PopoverTooltip.Trigger className="absolute top-0 left-0 size-full !cursor-help" />

          <PopoverTooltip.Content>
            {SCHEDULE_BLOCK_REASON_MESSAGES[scheduleBlockReason]}
          </PopoverTooltip.Content>
        </PopoverTooltip.Root>
      )}
    </Banner.Root>
  );
};
